import React, { Fragment } from 'react';
import classnames from 'classnames/bind';

import styles from '../ideaUpdateStyles.scss';

import Icon from 'buyside/components/presentation/Icon/icon';

import ShortRightArrowIcon from 'buyside/svgs/short_right_arrow.svg';
import TargetIcon from 'buyside/svgs/target.svg';
import ThermometerIcon from 'buyside/svgs/thermometer.svg';
import ClockIcon from 'buyside/svgs/clock.svg';
import LightningBoltVerticalIcon from 'buyside/svgs/lightning_bolt_vertical.svg';

const cx = classnames.bind(styles);

const deltaIcons = {
  'Target Price': TargetIcon,
  Timeframe: ClockIcon,
  Situation: ThermometerIcon,
  'Target Allocation': TargetIcon,
  Catalysts: LightningBoltVerticalIcon
};

const IdeaUpdateDelta = ({ changesHash, redacted }) => {
  const isCatalyst = changesHash.value === 'Catalysts';

  const labelDescriptionClasses = {
    labelDescription: true,
    catalyst: isCatalyst,
    blur: redacted
  };

  const hasArrowIcon = changesHash.removed && changesHash.added;
  return (
    <div className={styles.change}>
      <div>
        <Icon type={deltaIcons[changesHash.value]} style={styles.deltaIcon} />
      </div>
      <div className={styles.deltaContent}>
        <div className={styles.label}>{changesHash.value}</div>
        <div className={cx(labelDescriptionClasses)}>
          {(isCatalyst && (
            <Fragment>
              {changesHash.removed && (
                <span className={styles.rejectedText}>{changesHash.removed.join(', ')}</span>
              )}
              {changesHash.added && (
                <span className={styles.addedText}>{changesHash.added.join(', ')}</span>
              )}
            </Fragment>
          )) || (
            <Fragment>
              <span className={styles.rejectedText}>{changesHash.removed} </span>
              {hasArrowIcon && <Icon type={ShortRightArrowIcon} style={styles.buttonIcon} />}
              <span className={styles.addedText}>{changesHash.added}</span>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default IdeaUpdateDelta;
